import { jsx as c } from "react/jsx-runtime";
import { NRLogger as n } from "./contact-channels45.js";
import { attempt as u } from "./contact-channels54.js";
import { useContext as m, createContext as R, useCallback as C } from "react";
import { GoogleReCaptchaProvider as l, useGoogleReCaptcha as f } from "./contact-channels109.js";
const s = R({
  getRecaptchaToken: async () => {
    throw new Error("getRecaptchaToken not implemented");
  }
}), b = () => {
  const t = m(s);
  if (!t)
    throw new Error("useRecaptchaContext must be used within a RecaptchaProvider");
  return t;
}, x = ({ children: t, locale: e, origin: r }) => {
  const { executeRecaptcha: a } = f(), p = C(
    async (h) => {
      if (!a) {
        n.error("Contact Channels UI: Recaptcha", {
          message: "Recaptcha not available",
          locale: e,
          origin: r
        });
        return;
      }
      const { data: i, error: o } = await u(a(h || "contactChannelsSubmit"));
      return o ? (n.error("Contact Channels UI: Recaptcha", {
        ...o,
        locale: e,
        origin: r
      }), "") : i;
    },
    [a, e, r]
  );
  return /* @__PURE__ */ c(s.Provider, { value: { getRecaptchaToken: p }, children: t });
}, k = ({ children: t, useRecaptcha: e, locale: r, origin: a }) => e ? /* @__PURE__ */ c(
  l,
  {
    reCaptchaKey: "6LcTQGQjAAAAAPi6TjZ2Lql9__mY9JV7IcX6140Q",
    useEnterprise: !0,
    scriptProps: { id: "contact-channels-lib-rec" },
    children: /* @__PURE__ */ c(x, { locale: r, origin: a, children: t })
  }
) : t;
export {
  k as RecaptchaProvider,
  b as useRecaptchaContext
};
//# sourceMappingURL=contact-channels69.js.map
